import React from 'react';
import './App.css';
import Content from './modules/Content';
import FirebaseProvider from 'modules/Firebase/FirebaseProvider';
import ModalProvider from 'modules/Modal/ModalProvider';

function App() {
    return (
        <div className={'app'}>
            <FirebaseProvider>
                <ModalProvider>
                    <Content />
                </ModalProvider>
            </FirebaseProvider>
        </div>
    );
}

export default App;
